export default __webpack_public_path__ + "static/media/featured-hgtv.38e3e699.png";